import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  UserGroupIcon,
  UserIcon,
  ClipboardDocumentCheckIcon,
  WrenchScrewdriverIcon,
  Bars3Icon,
  XMarkIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';

const navItems = [
  { name: 'Dashboard', icon: HomeIcon, to: '/admin/dashboard' },
  { name: 'Clientes', icon: UserGroupIcon, to: '/admin/clients' },
  { name: 'Leads', icon: UserIcon, to: '/admin/leads' },
  { name: 'Ventas', icon: ChartBarIcon, to: '/admin/sales' },
  { name: 'Servicios', icon: WrenchScrewdriverIcon, to: '/admin/services' },
  { name: 'Landing Editor', icon: WrenchScrewdriverIcon, to: '/admin/landing-editor' },
  { name: 'BookMe Landing', icon: WrenchScrewdriverIcon, to: '/admin/bookme-landing' },
  { name: 'E-commerce', icon: ChartBarIcon, to: '/admin/ecommerce' },
  { name: 'Operaciones', icon: ClipboardDocumentCheckIcon, to: '/admin/operations' },
];

const AdminNavbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname.startsWith(path);

  const DesktopNav = () => (
    <div className="hidden md:block">
      <div className="-mx-2 overflow-x-auto pb-1" style={{ scrollbarWidth: 'none' }}>
        <ul className="flex w-max gap-2 rounded-2xl bg-[var(--admin-surface)]/90 px-2 py-2">
          {navItems.map(({ name, icon: Icon, to }) => {
            const active = isActive(to);
            return (
              <li key={name}>
                <Link
                  to={to}
                  className={[
                    'inline-flex min-w-[120px] items-center gap-2 rounded-full border px-3 py-2 text-[11px] font-semibold uppercase tracking-wide transition',
                    active
                      ? 'border-transparent bg-[var(--admin-primary)] text-white shadow-lg shadow-emerald-100'
                      : 'border-[var(--admin-border)] text-[var(--admin-muted)] hover:border-[var(--admin-primary)] hover:text-[var(--admin-primary)]',
                  ].join(' ')}
                >
                  <Icon className="h-4 w-4" />
                  {name}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );

  const MobileNav = () =>
    open ? (
      <div className="md:hidden">
        <div className="rounded-2xl border border-[var(--admin-border)] bg-white p-3 shadow-lg">
          <ul className="space-y-2">
            {navItems.map(({ name, icon: Icon, to }) => {
              const active = isActive(to);
              return (
                <li key={name}>
                  <Link
                    to={to}
                    onClick={() => setOpen(false)}
                    className={[
                      'flex items-center gap-3 rounded-2xl px-4 py-2 text-sm font-semibold',
                      active
                        ? 'bg-[var(--admin-primary)]/10 text-[var(--admin-primary)]'
                        : 'text-[var(--admin-text)] hover:bg-[var(--admin-surface)]',
                    ].join(' ')}
                  >
                    <Icon className="h-5 w-5 text-[var(--admin-primary)]" />
                    {name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    ) : null;

  return (
    <header className="sticky top-0 z-50 border-b border-[var(--admin-border)] bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <Link to="/admin/dashboard" className="flex items-center gap-3">
            <img
              src="/logo-bbts.png"
              alt="Puerto Rico Windows & Doors Logo"
              className="h-12 w-auto rounded-xl border border-[var(--admin-border)] bg-white p-2"
            />
            <div className="leading-tight">
              <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[var(--admin-muted)]">
                Puerto Rico Windows & Doors
              </p>
              <p className="text-lg font-bold text-[var(--admin-text)]">Panel Admin</p>
            </div>
          </Link>
          <button
            className="rounded-full border border-[var(--admin-border)] p-2 text-[var(--admin-text)] md:hidden"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="Abrir menú de administración"
          >
            {open ? <XMarkIcon className="h-5 w-5" /> : <Bars3Icon className="h-5 w-5" />}
          </button>
        </div>
        <DesktopNav />
        <MobileNav />
      </div>
    </header>
  );
};

export default AdminNavbar;
